import apiClient from "@/axios";

export const checkToken = async (token) => {
  const response = await apiClient.post("/check-token");
  return response;
};

export const register = async (name, email, password) => {
  const response = await apiClient.post("/auth/register", {
    name: name,
    email: email,
    password: password,
  });
  return response;
};

export const login = async (email, password) => {
  const response = await apiClient.post("/auth/login", {
    email: email,
    password: password,
  });
  return response;
}

export const logout = async () => {
  const response = await apiClient.post("/user/logout");
  return response;
}

export const googleLogin = async (token) => {
  const response = await apiClient.post("/auth/google/login", {
    token: token
  });
  return response;
}

export const changePassword = async (currentPassword, newPassword, confirmPassword) => {
  const response = await apiClient.post("/user/change-password", {
    currentPassword: currentPassword,
    newPassword: newPassword,
    confirmPassword: confirmPassword
  });
  return response;
}

export const handleForgotPassword = async(email) =>{
  const response = await apiClient.post('/auth/forgot-password', {email});
  return response;
}

export const handleResetPassword = async(token, email, password, confirmPassword) => {
  const response = await apiClient.post('/auth/reset-password', {
    token: token,
    email: email,
    password: password,
    password_confirmation: confirmPassword
  });
  return response;
}